import { PlanTierFeature } from "constants/planTierFeatures";

const Messages = {

  renewalDisabledTaggedMessage: "This feature has been disabled for your plan. Please reach out to [growth@scraperapi.com|contact_growth_email] or your account manager if you wish to change your current API credit plan.",

  cannotCancelBecauseOfUnpaidInvoicesMessage: "Cancellation not possible due to unpaid invoices. [Contact support|contact_support] if you have questions or need help.",

  apiKeyCardTooltipMessage: 'The API key is used to authenticate requests and is a unique number. If you think your key was exposed to a third party, you can generate a new one by clicking on the "manage" button.',

  // Billing V2
  billingV2: {
    payg: {
      ratePerThousand: 0.60,
      creditsPerUnit: 1000,
      description: "Get additional credits at $0.60 per 1,000 credits. Set a spending cap to control costs while preventing service interruption.",
    },

    enterprise: {
      features: [
        { label: "22,000,000+ API credits" },
        { label: "500+ Concurrent Threads" },
        { label: "Ultra Premium" },
        { label: "Unlimited AI Parsers", badge: "new", infoTooltip: "Each parser create or edit costs 30,000 credits." },
        { label: "Dedicated Support Team" },
        { label: "Slack Support" },
        { label: "Full crawler access" },
        { label: "Unlimited analytics history" },
        { label: "Pay as you go", infoTooltip: "Avoid interruptions, enable pay-as-you-go and set a spending cap." },
      ] as PlanTierFeature[],
      tagline: "Gain complete control and flexibility with personalised pricing.",
    },

    usageWarnings: {
      approachingBoth: "You're approaching your API credit and concurrency limits. Upgrade your plan to avoid service interruption.",
      approachingCredits: "You're approaching your API credit limit. Upgrade your plan to avoid service interruption.",
      approachingConcurrency: "You're approaching your concurrency limit. Upgrade your plan to avoid service interruption.",
    },
  },

};

export default Messages;
